;(function () {
    window.Dashboard = window.Dashboard || {};
    var Dashboard = window.Dashboard;

    const ordersStateParams = {
        IsSuccess: { dynamic: true },
        Channel: { dynamic: true },
        Store: { dynamic: true },
        CustomerName: { dynamic: true },
        EmailAddress: { dynamic: true },
        MobileNumber: { dynamic: true },
        FromDate: { dynamic: true },
        ToDate: { dynamic: true },
    }

    Dashboard.menuStates = {
        groups:
            [
                {
                    menuVal: "Campaigns",
                    iconClass: "icon-Campaigns",
                    permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                    callCenterItems: [],
                    brandItems: [
                        {
                            menuVal: "Campaigns",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: true,
                            subMenuItems: [
                                {
                                    subMenuVal: "New",
                                    defaultState: true,
                                    title: "New Campaign",
                                    stateConfig: {
                                        state: "app.brandcampaigns",
                                        url: "/campaigns/new/brand/:brandId",
                                        views: {
                                            "": {
                                                template: "<brand-campaigns></brand-campaigns>"
                                            },
                                            "campaignview@app.brandcampaigns": {
                                                template: "<campaign-wizard-select-template></campaign-wizard-select-template>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Scheduled",
                                    title: "Scheduled Campaigns",
                                    stateConfig: {
                                        state: "app.brandcampaigns.scheduledcampaigns",
                                        url: "^/campaigns/scheduledcampaigns/brand/:brandId",
                                        views: {
                                            "campaignview@app.brandcampaigns": {
                                                template: "<scheduled-campaigns></scheduled-campaigns>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Active",
                                    title: "Active Campaigns",
                                    stateConfig: {
                                        state: "app.brandcampaigns.currentcampaigns",
                                        url: "^/campaigns/currentcampaigns/brand/:brandId",
                                        views: {
                                            "campaignview@app.brandcampaigns": {
                                                template: "<current-campaigns></current-campaigns>"
                                            }
                                        }

                                    }
                                },
                                {
                                    subMenuVal: "Completed",
                                    title: "Completed Campaigns",
                                    stateConfig: {
                                        state: "app.brandcampaigns.finishedcampaigns",
                                        url: "^/campaigns/finishedcampaigns/brand/:brandId",
                                        views: {
                                            "campaignview@app.brandcampaigns": {
                                                template: "<finished-campaigns></finished-campaigns>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Cancelled",
                                    title: "Cancelled Campaigns",
                                    stateConfig: {
                                        state: "app.brandcampaigns.cancelledcampaigns",
                                        url: "^/campaigns/cancelledcampaigns/brand/:brandId",
                                        views: {
                                            "campaignview@app.brandcampaigns": {
                                                template: "<cancelled-campaigns></cancelled-campaigns>"
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigns.managecampaign",
                                url: "^/campaigns/managecampaign/:id/brand/:brandId",
                                views: {
                                    "campaignview@app.brandcampaigns": {
                                        template: "<manage-campaign></manage-campaign>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigns.customise",
                                url: "^/campaigns/new/brand/:brandId?CampaignTemplateId",
                                views: {
                                    "": {
                                        template: "<brand-campaigns></brand-campaigns>"
                                    },
                                    "campaignview@app.brandcampaigns": {
                                        template: "<campaign-wizard-customise></campaign-wizard-customise>"
                                    }
                                },
                                params: {
                                    CampaignTemplateId: {
                                        dynamic: true
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigns.summary",
                                url: "^/campaigns/new/brand/:brandId?CampaignTemplateId",
                                views: {
                                    "": {
                                        template: "<brand-campaigns></brand-campaigns>"
                                    },
                                    "campaignview@app.brandcampaigns": {
                                        template: "<campaign-wizard-summary></campaign-wizard-summary>"
                                    }
                                },
                                params: {
                                    CampaignTemplateId: {
                                        dynamic: true
                                    }
                                }
                            }
                        }
                    ],
                    storeItems: [
                        {
                            menuVal: "Campaigns",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.storesubscription",
                                url: "/subscription/:id/store/:storeId",
                                views: {

                                    // Main view template
                                    "": {
                                        template: "<store-subscription></store-subscription>"
                                    }
                                }
                            },
                        },
                        {
                            menuVal: "Campaigns",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: true,
                            subMenuItems: [
                                {
                                    subMenuVal: "New",
                                    defaultState: true,
                                    stateConfig: {
                                        state: "app.storecampaigns",
                                        url: "/campaigns/new/store/:storeId",
                                        views: {

                                            //
                                            "": {
                                                template: "<store-campaigns></store-campaigns>"
                                            },
                                            "campaignview@app.storecampaigns": {
                                                template: "<campaign-wizard-select-template></campaign-wizard-select-template>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Scheduled",
                                    stateConfig: {
                                        state: "app.storecampaigns.scheduledcampaigns",
                                        url: "^/campaigns/scheduledcampaigns/store/:storeId",
                                        views: {
                                            "campaignview@app.storecampaigns": {
                                                template: "<scheduled-campaigns></scheduled-campaigns>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Active",
                                    stateConfig: {
                                        state: "app.storecampaigns.currentcampaigns",
                                        url: "^/campaigns/currentcampaigns/store/:storeId",
                                        views: {
                                            "campaignview@app.storecampaigns": {
                                                template: "<current-campaigns></current-campaigns>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Completed",
                                    stateConfig: {
                                        state: "app.storecampaigns.finishedcampaigns",
                                        url: "^/campaigns/finishedcampaigns/store/:storeId",
                                        views: {
                                            "campaignview@app.storecampaigns": {
                                                template: "<finished-campaigns></finished-campaigns>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Cancelled",
                                    stateConfig: {
                                        state: "app.storecampaigns.cancelledcampaigns",
                                        url: "^/campaigns/cancelledcampaigns/store/:storeId",
                                        views: {
                                            "campaignview@app.storecampaigns": {
                                                template: "<cancelled-campaigns></cancelled-campaigns>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Voucher Request",
                                    stateConfig: {
                                        state: "app.voucherrequest",
                                        url: "/voucherrequest/voucherrequest/:storeId",
                                        views: {
                                            // Main view template
                                            "": {
                                                template: "<voucher-request></voucher-request>"
                                            }
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            menuVal: "",
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.storecampaigns.list",
                                url: "^/campaigns/new/store/:storeId",
                                views: {
                                    "": {
                                        template: "<store-campaigns></store-campaigns>"
                                    },
                                    "campaignview@app.storecampaigns": {
                                        template: "<campaign-wizard-select-template></campaign-wizard-select-template>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.storecampaigns.customise",
                                url: "^/campaigns/new/store/:storeId?CampaignTemplateId",
                                views: {
                                    "": {
                                        template: "<store-campaigns></store-campaigns>"
                                    },
                                    "campaignview@app.storecampaigns": {
                                        template: "<campaign-wizard-customise></campaign-wizard-customise>"
                                    }
                                },
                                params: {
                                    CampaignTemplateId: {
                                        dynamic: true
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageCampaigns ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.storecampaigns.summary",
                                url: "^/campaigns/new/store/:storeId?CampaignTemplateId",
                                views: {
                                    "": {
                                        template: "<store-campaigns></store-campaigns>"
                                    },
                                    "campaignview@app.storecampaigns": {
                                        template: "<campaign-wizard-summary></campaign-wizard-summary>"
                                    }
                                },
                                params: {
                                    CampaignTemplateId: {
                                        dynamic: true
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    menuVal: "Restaurant",
                    iconClass: "icon-restaurant",
                    permissions: [
                        Dashboard.Models.Lookups.Permissions.StoreSettings,
                        Dashboard.Models.Lookups.Permissions.OutOfStock
                    ],
                    brandItems: [],
                    callCenterItems: [],
                    storeItems: [
                        {
                            menuVal: "Restaurant",
                            permissions: [
                                Dashboard.Models.Lookups.Permissions.StoreSettings,
                                Dashboard.Models.Lookups.Permissions.OutOfStock
                            ],
                            showInMenu: false,
                            defaultState: true,
                            subMenuItems: [
                                {
                                    subMenuVal: "Settings",
                                    permissions: [ Dashboard.Models.Lookups.Permissions.StoreSettings ],
                                    stateConfig: {
                                        state: "app.storesettings",
                                        url: "/store/settings/:storeId",
                                        views: {
                                            "": {
                                                template: "<store-settings></store-settings>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Out of Stock",
                                    permissions: [ Dashboard.Models.Lookups.Permissions.OutOfStock ],
                                    stateConfig: {
                                        state: "app.storeoutofstock",
                                        url: "/store/outofstock/:storeId",
                                        views: {
                                            "": {
                                                template: "<out-of-stock></out-of-stock>"
                                            }
                                        },
                                    }
                                },
                                {
                                    subMenuVal: "Delivery Zones",
                                    permissions: [ Dashboard.Models.Lookups.Permissions.ManageDeliveryZones ],
                                    stateConfig: {
                                        state: "app.deliveryzones",
                                        url: "/store/deliveryzones/:storeId",
                                        views: {
                                            "": {
                                                template: "<delivery-zones></delivery-zones>"
                                            }
                                        },
                                    }
                                },
                            ]
                        },
                    ],
                },
                {
                    menuVal: "Users",
                    iconClass: "icon-Users",
                    permissions: [
                        Dashboard.Models.Lookups.Permissions.ViewUsers,
                    ],
                    brandItems: [
                        {
                            menuVal: "List Users",
                            title: 'Manage Users',
                            showInMenu: true,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageUsers ],
                            defaultState: true,
                            stateConfig: {
                                state: "app.brandusers",
                                url: "/users/brand/:brandId",
                                views: {

                                    // Main view template
                                    "": {
                                        template: "<brand-users></brand-users>"
                                    },
                                    "userview@app.brandusers": {
                                        template: "<list-users></list-users>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "Add User",
                            showInMenu: true,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageUsers ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandusers.adduser",
                                url: "^/users/add/brand/:brandId",
                                views: {
                                    "userview@app.brandusers": {
                                        template: "<manage-user></manage-user>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageUsers ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandusers.edituser",
                                url: "^/users/edit/:id/brand/:brandId",
                                params: { Id: null },
                                views: {
                                    "userview@app.brandusers": {
                                        template: "<manage-user></manage-user>"
                                    }
                                }
                            }
                        }
                    ],
                    callCenterItems: [
                        {
                            menuVal: "List Users",
                            title: 'Manage Users',
                            showInMenu: true,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ViewUsers ],
                            defaultState: true,
                            stateConfig: {
                                state: "app.callcenterusers",
                                url: "/users/callcenter/:callCenterId",
                                views: {

                                    // Main view template
                                    "": {
                                        template: "<call-center-users></call-center-users>"
                                    },
                                    "userview@app.callcenterusers": {
                                        template: "<list-users></list-users>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "Add User",
                            showInMenu: true,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageUsers ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.callcenterusers.adduser",
                                url: "^/users/add/callcenter/:callCenterId",
                                views: {
                                    "userview@app.callcenterusers": {
                                        template: "<manage-user></manage-user>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            title: "Manage Users",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageUsers ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.callcenterusers.edituser",
                                url: "^/users/edit/:id/callcenter/:callCenterId",
                                params: { Id: null },
                                views: {
                                    "userview@app.callcenterusers": {
                                        template: "<manage-user></manage-user>"
                                    }
                                }
                            }
                        }
                    ],
                    storeItems: [
                        {
                            menuVal: "List Users",
                            title: 'Manage Users',
                            showInMenu: true,
                            permissions: [
                                Dashboard.Models.Lookups.Permissions.ManageUsers,
                                Dashboard.Models.Lookups.Permissions.ManageNonAdminUsers
                            ],
                            defaultState: true,
                            stateConfig: {
                                state: "app.storeusers",
                                url: "/users/store/:storeId",
                                views: {

                                    // Main view template
                                    "": {
                                        template: "<store-users></store-users>"
                                    },
                                    "userview@app.storeusers": {
                                        template: "<list-users></list-users>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "Add User",
                            showInMenu: true,
                            permissions: [
                                Dashboard.Models.Lookups.Permissions.ManageUsers,
                                Dashboard.Models.Lookups.Permissions.ManageNonAdminUsers
                            ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.storeusers.adduser",
                                url: "^/users/add/store/:storeId",
                                views: {
                                    "userview@app.storeusers": {
                                        template: "<manage-user></manage-user>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [
                                Dashboard.Models.Lookups.Permissions.ManageUsers,
                                Dashboard.Models.Lookups.Permissions.ManageNonAdminUsers
                            ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.storeusers.edituser",
                                url: "^/users/edit/:id/store/:storeId",
                                params: { Id: null },
                                views: {
                                    "userview@app.storeusers": {
                                        template: "<manage-user></manage-user>"
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    menuVal: "Orders",
                    iconClass: "icon-Orders",
                    permissions: [
                        Dashboard.Models.Lookups.Permissions.OrdersAccess,
                        Dashboard.Models.Lookups.Permissions.ViewOnlineOrders
                    ],
                    callCenterItems: [],
                    brandItems: [
                        {
                            menuVal: "Orders",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.BrandCustomerSupportAgent ],
                            defaultState: true,
                            subMenuItems: [
                                {
                                    subMenuVal: "Order History",
                                    stateConfig: {
                                        state: "app.brandorders",
                                        url: "/orders/brand/:brandId?Store&IsSuccess&Channel&CustomerName&EmailAddress&MobileNumber&FromDate&ToDate",
                                        views: {
                                            // Main view template
                                            '': {
                                                template: '<brand-orders></brand-orders>'
                                            },
                                            "orderview@app.brandorders": {
                                                template: '<list-orders></list-orders>'
                                            }
                                        },
                                        params: { ...ordersStateParams }
                                    }
                                }
                            ]
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.BrandCustomerSupportAgent ],
                            title: "View Order",
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandorders.vieworder",
                                url: "^/orders/view/:id/brand/:brandId",
                                params: { Id: null },
                                views: {
                                    "orderview@app.brandorders": {
                                        template: '<view-order></view-order>'
                                    }
                                }
                            }
                        },
                    ],
                    storeItems: [
                        {
                            menuVal: "Orders",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.OrdersAccess ],
                            defaultState: true,
                            subMenuItems: [
                                {
                                    subMenuVal: "OrderUp",
                                    permissions: [ Dashboard.Models.Lookups.Permissions.ViewOnlineOrders ],
                                    stateConfig: {
                                        state: "app.orderup",
                                        url: "/orders/order-up/:storeId",
                                        views: {
                                            "": {
                                                template: "<order-up-main></order-up-main>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Order History",
                                    permissions: [ Dashboard.Models.Lookups.Permissions.OrdersAccess ],
                                    stateConfig: {
                                        state: "app.storeorders",
                                        url: "/orders/store/:storeId?IsSuccess&Channel&CustomerName&EmailAddress&MobileNumber&FromDate&ToDate",
                                        views: {
                                            // Main view template
                                            "": {
                                                template: "<store-orders></store-orders>"
                                            },
                                            "orderview@app.storeorders": {
                                                template: "<list-orders></list-orders>"
                                            }

                                        },
                                        params: { ...ordersStateParams }
                                    }
                                }
                            ]
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.OrdersAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.storeorders.vieworder",
                                url: "^/orders/view/:id/store/:storeId",
                                params: { Id: null },
                                views: {
                                    "orderview@app.storeorders": {
                                        template: "<view-order></view-order>"
                                    }
                                }
                            }
                        }
                    ],
                },
                {
                    menuVal: "Campaign Designer",
                    iconClass: "icon-CampaignDesigner",
                    permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                    callCenterItems: [],
                    storeItems: [],
                    brandItems: [
                        {
                            menuVal: "Campaign Designer",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: true,
                            subMenuItems: [
                                {
                                    subMenuVal: "Draft Templates",
                                    stateConfig: {
                                        state: "app.brandcampaigntemplates",
                                        url: "/campaigndesigner/list/draft/brand/:brandId",
                                        views: {
                                            "": {
                                                template: "<brand-campaign-designer></brand-campaign-designer>"
                                            },
                                            "campaigndesignerview@app.brandcampaigntemplates": {
                                                template: "<campaign-template-listing template-type=\"draft\"></campaign-template-listing>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Published Templates",
                                    stateConfig: {
                                        state: "app.brandcampaigntemplates.published",
                                        url: "^/campaigndesigner/list/published/brand/:brandId",
                                        views: {
                                            "campaigndesignerview@app.brandcampaigntemplates": {
                                                template: "<campaign-template-listing template-type=\"published\"></campaign-template-listing>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Archived Templates",
                                    stateConfig: {
                                        state: "app.brandcampaigntemplates.archived",
                                        url: "^/campaigndesigner/list/archived/brand/:brandId",
                                        views: {
                                            "campaigndesignerview@app.brandcampaigntemplates": {
                                                template: "<campaign-template-listing template-type=\"archived\"></campaign-template-listing>"
                                            }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "Manage Target Sources",
                                    stateConfig: {
                                        state: "app.brandcampaigntemplates.targetsources",
                                        url: "^/campaigndesigner/targetsources/list/brand/:brandId",
                                        views: {
                                            "campaigndesignerview@app.brandcampaigntemplates": {
                                                template: "<list-target-sources></list-target-sources>"
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.manage",
                                url: "^/campaigndesigner/manage/basic/brand/:brandId?CampaignTemplateGuid",
                                views: {
                                    "campaigndesignerview@app.brandcampaigntemplates": {
                                        template: "<manage-campaign-template></manage-campaign-template>"
                                    },
                                    "managecampaigntemplateview@app.brandcampaigntemplates.manage": {
                                        template: "<manage-campaign-template-basic campaign-template=\"campaignTemplate\" user-context=\"userContext\"></manage-campaign-template-basic>"
                                    }
                                },
                                params: {
                                    CampaignTemplateGuid: { dynamic: true }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.manage.stores",
                                url: "^/campaigndesigner/manage/stores/brand/:brandId?CampaignTemplateGuid",
                                views: {
                                    "managecampaigntemplateview@app.brandcampaigntemplates.manage": {
                                        template: "<manage-campaign-template-stores campaign-template=\"campaignTemplate\" user-context=\"userContext\"></manage-campaign-template-stores>"
                                    }
                                },
                                params: {
                                    CampaignTemplateGuid: { dynamic: true }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.manage.vouchers",
                                url: "^/campaigndesigner/manage/vouchers/brand/:brandId?CampaignTemplateGuid",
                                views: {
                                    "managecampaigntemplateview@app.brandcampaigntemplates.manage": {
                                        template: "<manage-campaign-template-vouchers campaign-template=\"campaignTemplate\" user-context=\"userContext\"></manage-campaign-template-vouchers>"
                                    }
                                },
                                params: {
                                    CampaignTemplateGuid: { dynamic: true }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.manage.comms",
                                url: "^/campaigndesigner/manage/comms/brand/:brandId?CampaignTemplateGuid",
                                views: {
                                    "managecampaigntemplateview@app.brandcampaigntemplates.manage": {
                                        template: "<manage-campaign-template-comms campaign-template=\"campaignTemplate\" user-context=\"userContext\"></manage-campaign-template-comms>"
                                    }
                                },
                                params: {
                                    CampaignTemplateGuid: { dynamic: true }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.manage.menuscripts",
                                url: "^/campaigndesigner/manage/menuscripts/brand/:brandId?CampaignTemplateGuid",
                                views: {
                                    "managecampaigntemplateview@app.brandcampaigntemplates.manage": {
                                        template: "<manage-campaign-template-menuscripts campaign-template=\"campaignTemplate\" user-context=\"userContext\"></manage-campaign-template-menuscripts>"
                                    }
                                },
                                params: {
                                    CampaignTemplateGuid: { dynamic: true }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.manage.confirm",
                                url: "^/campaigndesigner/manage/confirm/brand/:brandId?CampaignTemplateGuid",
                                views: {
                                    "managecampaigntemplateview@app.brandcampaigntemplates.manage": {
                                        template: "<manage-campaign-template-confirmation campaign-template=\"campaignTemplate\" user-context=\"userContext\"></manage-campaign-template-confirmation>"
                                    }
                                },
                                params: {
                                    CampaignTemplateGuid: { dynamic: true }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.targetsources.add",
                                url: "^/campaigndesigner/targetsources/add/brand/:brandId",
                                views: {
                                    "campaigndesignerview@app.brandcampaigntemplates": {
                                        template: "<manage-target-source></manage-target-source>"
                                    }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [ Dashboard.Models.Lookups.Permissions.ManageUsers ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.brandcampaigntemplates.targetsources.edit",
                                url: "^/campaigndesigner/targetsources/edit/:id/brand/:brandId",
                                params: { Id: null },
                                views: {
                                    "campaigndesignerview@app.brandcampaigntemplates": {
                                        template: "<manage-target-source></manage-target-source>"
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    menuVal: "Landing Pages",
                    iconClass: "icon-LandingPages",
                    permissions: [ Dashboard.Models.Lookups.Permissions.ViewLandingPages ],
                    storeItems: [],
                    callCenterItems: [],
                    brandItems: [
                        {
                            menuVal: "Landing Pages",
                            permissions: [
                                Dashboard.Models.Lookups.Permissions.ViewLandingPages,
                                Dashboard.Models.Lookups.Permissions.AddLandingPage,
                                Dashboard.Models.Lookups.Permissions.EditLandingPage
                            ],
                            defaultState: true,
                            subMenuItems: [
                                {
                                    subMenuVal: "New Page",
                                    stateConfig: {
                                        state: "app.landingpages.details",
                                        url: "^/landingpages/:brandId/details?pageId",
                                        views: {
                                            "landingpagesview@app.landingpages": {
                                                template: "<manage-landing-page-wizard></manage-landing-page-wizard>"
                                            },
                                            "managelandingpageview@app.landingpages.details": {
                                                template: "<landing-page-details></landing-page-details>"
                                            }
                                        },
                                        params: {
                                            pageId: { dynamic: true }
                                        }
                                    }
                                },
                                {
                                    subMenuVal: "View All",
                                    stateConfig: {
                                        state: "app.landingpages",
                                        url: "^/landingpages/:brandId/list",
                                        views: {
                                            "": {
                                                template: "<brand-landing-pages></brand-landing-pages>"
                                            },
                                            "landingpagesview@app.landingpages": {
                                                template: "<list-landing-pages></list-landing-pages>"
                                            }
                                        },
                                    }
                                },
                            ]
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [
                                Dashboard.Models.Lookups.Permissions.ViewLandingPages,
                                Dashboard.Models.Lookups.Permissions.AddLandingPage,
                                Dashboard.Models.Lookups.Permissions.EditLandingPage
                            ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.landingpages.template",
                                url: "^/landingpages/:brandId/template?pageId",
                                views: {
                                    "landingpagesview@app.landingpages": {
                                        template: "<manage-landing-page-wizard></manage-landing-page-wizard>"
                                    },
                                    "managelandingpageview@app.landingpages.template": {
                                        template: "<template-setup></template-setup>"
                                    }
                                },
                                params: {
                                    pageId: { dynamic: true }
                                }
                            }
                        },
                        {
                            menuVal: "",
                            showInMenu: false,
                            permissions: [
                                Dashboard.Models.Lookups.Permissions.ViewLandingPages,
                                Dashboard.Models.Lookups.Permissions.AddLandingPage,
                                Dashboard.Models.Lookups.Permissions.EditLandingPage
                            ],
                            defaultState: false,
                            stateConfig: {
                                state: "app.landingpages.placement",
                                url: "^/landingpages/:brandId/placement?pageId",
                                views: {
                                    "landingpagesview@app.landingpages": {
                                        template: "<manage-landing-page-wizard></manage-landing-page-wizard>"
                                    },
                                    "managelandingpageview@app.landingpages.placement": {
                                        template: "<placement-details></placement-details>"
                                    }
                                },
                                params: {
                                    pageId: { dynamic: true }
                                }
                            }
                        },
                    ]
                }

            ]
    };

    Dashboard.getPermissionsForState = function (state) {
        if (!state) {
            return []
        }

        function getPermissionsInGroupForMatchingState(group, items) {
            return items.flatMap((item) => {
                const subMenuItem = item.subMenuItems?.find(subMenuItem => subMenuItem.stateConfig.state === state)
                if (subMenuItem) {
                    return subMenuItem.permissions || item.permissions;
                }
                if (item.stateConfig?.state === state) {
                    return item.permissions
                }
                return []
            })
        }

        return Dashboard.menuStates.groups.reduce((acc, cur) => {
            return [
                ...acc,
                ...getPermissionsInGroupForMatchingState(cur, cur.brandItems),
                ...getPermissionsInGroupForMatchingState(cur, cur.callCenterItems),
                ...getPermissionsInGroupForMatchingState(cur, cur.storeItems),
            ]
        }, [])
    }

})();
